import React, { Component } from 'react';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import SentActions from './ItemActions/SentActions';
import ReadyActions from './ItemActions/ReadyActions';
import CanceledActions from './ItemActions/CanceledActions';
import CompletedActions from './ItemActions/CompletedActions';
import ScheduledActions from './ItemActions/ScheduledActions';

import { Link } from 'react-router-dom';

class List extends Component {

  formatDate(date) {
    return moment.tz(date.date, date.timezone).local().format("LLL");
  }

  render() {
    const columns = [
      {
        name: 'Status',
        width: '225px',
        sort: false,
        cell: row => {
          if (row.status === 'READY' && row.appointmentType === 'telehealth') {
            return <Link className="btn btn-success" to={`/telehealth/${row.id}`}>Join</Link>
          }

          return <span className='badge badge-info text-uppercase'>{row.status}</span>
        }
      },
      {
        name: 'Type',
        sort: false,
        cell: row => {
          return <div>
            <b style={{ fontSize: 'medium' }}>{row.appointmentType === 'axs-links' ? 'Form' : 'Telehealth'}</b> <br />
            <div className="text-muted font-weight-light pt-2">
              {row.appointmentType === 'telehealth' ? "Appt Date: " : "Complete By: "}
              {row.appointmentType === 'telehealth' ? this.formatDate(row.appointmentDate) : this.formatDate(row.completeByDate)}
            </div>
          </div>
        }
      },
      {
        name: 'Provider',
        sort: false,
        cell: row => {
          return row.providerGroup.name
        }
      },
      {
        name: 'Form / Pre-Visit Questions',
        sort: false,
        cell: row => {
          return row.questionnaire.title
        }
      },
      {
        button: true,
        width: '225px',
        sort: false,
        style: { justifyContent: 'left' },
        cell: (row) => {
          const type = row.appointmentType === "axs-links" ? 'Form' : 'Telehealth';
          const date = row.appointmentType === "axs-links" ? row.completeByDate.date : row.appointmentDate.date;

          if (row.status === 'SCHEDULED') {
            return <ScheduledActions
              type={type}
              date={date}
              eventItem={row}
              cancelHandler={this.props.cancelHandler}
              rescheduleItem={this.props.rescheduleEventItem}
            />
          }
          if (row.status === 'SENT') {
            return <SentActions
              type={type}
              date={date}
              eventId={this.props.eventId}
              eventItem={row}
              cancelHandler={this.props.cancelHandler}
              rescheduleItem={this.props.rescheduleEventItem}
            />
          }
          if (row.appointmentType === "telehealth" && row.status === 'READY') {
            return <ReadyActions
              type='Telehealth'
              date={row.appointmentDate.date}
              eventItem={row}
              cancelHandler={this.props.cancelHandler}
              rescheduleItem={this.props.rescheduleEventItem}
            />
          }
          if (row.status === 'COMPLETED') {
            return <CompletedActions eventItem={row} />
          }
          if (row.status === 'CANCELED') {
            return <CanceledActions eventItem={row} />
          }
        }
      }
    ];

    return (
      <div className="row">
        <div className="col-lg-12 mt-3">
          <div className="row">
            <div className="col-lg-12">
              <DataTable
                data={this.props.items}
                columns={columns}
                striped={true}
                noHeader={true}
                customStyles={{ cells: { style: { fontSize: '14px', paddingTop: '1em', paddingBottom: '1em' } }, }}
                noDataComponent="There are no event items to display"
                progressPending={this.props.loading}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default List;